import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IShippingMovements,
  IShippingMovementsInitialState,
} from "./shippingMovementsModel";
import {
  getAllShippingMovements,
  createShippingMovements,
  deleteShippingMovements,
  getShippingMovementsByID,
  updateShippingMovements,
} from "./services/shippingMovements.services";

const initialState: IShippingMovementsInitialState = {
  loading: false,
  error: "",
  FilterCustomSM: {
    vessels_name: "",
  },
  ShippingMovementsID: null,
  ShippingMovementsGUID: "",
  ShippingMovementsList: [],
  ShippingMovementsDetail: {
    shipping_movements: "",
    port_id: null,
    eta: "",
    cut_off_datetime: "",
    vessels_name: "",
    voj_no: "",
    vcn: "",
    line_id: "",
    agent_id: "",
    will_load_for: "",
    etd: "",
  },
};

const shippingMovementsSlice = createSlice({
  name: "shippingMovements",
  initialState,
  reducers: {
    clearShippingMovementsDetails: (state) => {
      state.ShippingMovementsDetail = initialState.ShippingMovementsDetail;
    },
    setShippingMovementsID: (state, action) => {
      state.ShippingMovementsID = action.payload;
    },
    clearShippingMovementsID: (state) => {
      state.ShippingMovementsID = initialState.ShippingMovementsID;
    },
    setShippingMovementsGUID: (state, action) => {
      state.ShippingMovementsGUID = action.payload;
    },
    clearShippingMovementsGUID: (state) => {
      state.ShippingMovementsGUID = initialState.ShippingMovementsGUID;
    },
    setFilterCustomSM: (state, action) => {
      state.FilterCustomSM = action.payload;
    },
    clearFilterCustomSM: (state) => {
      state.FilterCustomSM = initialState.FilterCustomSM;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllShippingMovements.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllShippingMovements.fulfilled,
      (state, action: PayloadAction<IShippingMovements[]>) => {
        state.loading = false;
        state.ShippingMovementsList = action.payload || [];
      }
    );
    builder.addCase(getAllShippingMovements.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ShippingMovementsList = [];
    });

    builder.addCase(createShippingMovements.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createShippingMovements.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createShippingMovements.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateShippingMovements.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateShippingMovements.fulfilled, (state) => {
      state.loading = true;
    });
    builder.addCase(updateShippingMovements.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteShippingMovements.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteShippingMovements.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteShippingMovements.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getShippingMovementsByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getShippingMovementsByID.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.ShippingMovementsDetail = action.payload;
      }
    );
    builder.addCase(getShippingMovementsByID.rejected, (state, action) => {
      state.loading = false;
      state.ShippingMovementsDetail = initialState.ShippingMovementsDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearShippingMovementsDetails,
  clearShippingMovementsID,
  setShippingMovementsID,
  clearShippingMovementsGUID,
  setShippingMovementsGUID,
  setFilterCustomSM,
  clearFilterCustomSM,
} = shippingMovementsSlice.actions;
export default shippingMovementsSlice.reducer;
